import Vue from 'vue'
import APIBase from './APIBase'
import Session from '@/session/Session.js'

var api = new APIBase('authenticate')

api.getAuthToken = function() {
  return Vue.axios.defaults.headers.common['x-auth-token']
}

api.tryLogin = function(username, password) {
  // delete Vue.http.headers.common['x-auth-token']

  // Si el token esta expirado pero se envia, ocurre lo siguiente:
  // * se autentica OK con Authorization
  // * no se devuelve ningun token

  Vue.axios.defaults.headers.common['Authorization'] = 'Basic ' + btoa(username + ':' + password);
  delete Vue.axios.defaults.headers.common['x-auth-token']

  let r = api.POSTWithHeaders('', {}, {
    // 'Authorization': 'Basic ' + btoa(username + ':' + password),
    'X-Requested-With': 'XMLHttpRequest'
  })

  r.then(response => {
    window.console.log('login::response>', response)

    var token = response.headers['x-auth-token']

    window.console.log('login::token>', token)
    if(token) {
      Vue.axios.defaults.headers.common['x-auth-token'] = token

      delete Vue.axios.defaults.headers.common['Authorization']
    }

    let user = (response.data.user || {})
    localStorage.setItem('portalname', username)

    Session.setUser(user)

      /*
    Utils.session.authToken = token
    let user = response.data.user
    Utils.session.user = user
    Utils.session.queueID = (response.data.user.queue || {}).id
    Utils.session.deviceUUID = username
    window.console.log('Utils.session>', Utils.session)
    */

    Promise.resolve(response.data)
  })

  return r
}

api.logout = function (component) {

  api.GET('/logout')
  window.vueApp.$root.session.user = null
  delete Vue.axios.defaults.headers.common['x-auth-token']

  component.$emit("onUserLogin", null)
}

export default api

